<template>
    <div class="container">
        <h1 v-if="products" class="heading">Feedback Approval - Order ID: {{ products[0].shopify_order_number }}</h1>

        <div v-if="loading" class="loading">
            <p>Loading...</p>
        </div>

        <div v-else>
            <!-- Product Images Section -->
            <div class="product-section">
                <div class="product-container">
                    <div v-for="(product, index) in products" :key="index" class="product-image-wrapper">
                        <img :src="product.image" alt="Product" class="product-image" />
                        <p class="image-label">Product Image</p>
                    </div>
                </div>
            </div>

            <!-- Feedback Images Section -->
            <div class="feedback-section">
                <h3 class="subheading">Feedback Images:</h3>

                <!-- Action Buttons -->
                <div class="action-buttons">
                    <button class="approve-all-button" @click="approveAllFeedback">
                        Approve All
                    </button>
                    <button class="reject-all-button" @click="rejectAllFeedback">
                        Reject All
                    </button>
                </div>

                <!-- Feedback Images -->
                <div class="feedback-container">
                    <div v-for="(feedback, index) in feedbackImages" :key="feedback.id" class="feedback-card">
                        <img :src="feedback.message" alt="Feedback" class="feedback-image" />
                        <p class="image-label">Feedback Image {{ index + 1 }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";

export default {
    name: "FeedbackMediaApprove",
    data() {
        return {
            products: null,
            loading: true,
            orderId: 0,
            feedbackImages: null,
            options: {
                headers: {
                    "Access-Control-Allow-Headers":
                        "X-Custom-Header, Access-Control-Request-Headers"
                },
            },
        };
    },
    mounted() {
        this.orderId = this.$route.query.orderId;

        const feedbackImagesUrl = BASE_URL + `whatsapp/unApprovedMediaMessages?orderId=${this.orderId}`;
        const orderProductsURL = BASE_URL + `orders/orderProducts?id=${this.orderId}`;

        // Perform both API calls in parallel
        Promise.all([
            axios.get(feedbackImagesUrl, this.options),
            axios.get(orderProductsURL, this.options)
        ])
            .then(([feedbackResponse, productsResponse]) => {
                console.log(feedbackResponse);
                console.log(productsResponse);
                this.feedbackImages = feedbackResponse.data;
                this.products = productsResponse.data;
                this.loading = false;
            })
            .catch((error) => {
                console.log('Error fetching data:', error);
            });
    },
    methods: {
        async approveAllFeedback() {
            try {
                var url = BASE_URL + `reviews/approveImage?id=${this.orderId}`;
                await axios.get(url);
                this.feedbackImages = [];
            } catch (error) {
                console.error("Error approving all feedback:", error);
            }
        },
        async rejectAllFeedback() {
            try {
                var url = BASE_URL + `whatsapp/rejectMedia?orderId=${this.orderId}`;
                await axios.get(url);
                this.feedbackImages = [];
            } catch (error) {
                console.error("Error rejecting all feedback:", error);
            }
        },
    }
};
</script>

<style scoped>
/* Container and Layout */
.container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.heading {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.loading {
    text-align: center;
    font-size: 16px;
    color: gray;
}

.product-section,
.feedback-section {
    margin-bottom: 20px;
}

.product-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.product-image-wrapper {
    text-align: center;
    max-width: 200px;
    margin: 0 auto;
}

.product-image {
    width: 100%;
    height: auto;
    max-height: 150px;
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.feedback-section .action-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
}

.feedback-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.feedback-card {
    background: #fff;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    width: 220px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.feedback-image {
    width: 100%;
    height: auto;
    max-height: 150px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.image-label {
    margin-top: 8px;
    font-weight: 500;
    color: #555;
}

/* Buttons */
button {
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.approve-all-button {
    background-color: #4caf50;
    color: white;
}

.approve-all-button:hover {
    background-color: #45a049;
}

.reject-all-button {
    background-color: #f44336;
    color: white;
}

.reject-all-button:hover {
    background-color: #e53935;
}
</style>
